import React from "react";
export default function AppPageHeader() {
    return React.createElement("div", { className: "flex-space-between pr-1" });
}
